// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_hf","advertCardPhoto__image":"c-a_hg"};